// Values are sent to the API as-is (0-1 range).
export enum ClusteringBias {
  Lowest = 0,
  Low = 0.25,
  Mid = 0.5,
  High = 0.75,
  Highest = 1
}

export const CLUSTERING_BIAS_OPTIONS = [
  { value: ClusteringBias.Lowest, labelKey: "widget-settings.clustering-bias.lowest" },
  { value: ClusteringBias.Low, labelKey: "widget-settings.clustering-bias.low" },
  { value: ClusteringBias.Mid, labelKey: "widget-settings.clustering-bias.mid" },
  { value: ClusteringBias.High, labelKey: "widget-settings.clustering-bias.high" },
  { value: ClusteringBias.Highest, labelKey: "widget-settings.clustering-bias.highest" }
] as const;

// Widgets saved before the enum existed stored 0-100 values; map them onto the closest option.
export function normalizeClusteringBias(stored?: number | null): ClusteringBias {
  if (stored === undefined || stored === null) return ClusteringBias.Mid;
  const fraction = stored > 1 ? stored / 100 : stored;
  return CLUSTERING_BIAS_OPTIONS.reduce((closest, option) =>
    Math.abs(option.value - fraction) < Math.abs(closest - fraction) ? option.value : closest,
    ClusteringBias.Mid as ClusteringBias
  );
}
